import Header from "./components/Header";
import Hero from "./components/Hero";
import IntentNavigation from "./components/IntentNavigation";
import Services from "./components/Services";
import MotorProblems from "./components/MotorProblems";
import Reconditioned from "./components/Reconditioned";
import B2BBlock from "./components/B2BBlock";
import GroupHP from "./components/GroupHP";
import Segments from "./components/Segments";
import About from "./components/About";
import Videos from "./components/Videos";
import Process from "./components/Process";
import Gallery from "./components/Gallery";
import Authority from "./components/Authority";
import FAQ from "./components/FAQ";
import FinalCTA from "./components/FinalCTA";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import MobileBottomBar from "./components/MobileBottomBar";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 pb-16 md:pb-0">
      <Header />
      <main>
        <Hero />
        <IntentNavigation />
        <Services />
        <MotorProblems />
        <Reconditioned />
        <B2BBlock />
        <GroupHP />
        <Segments />
        <About />
        <Videos />
        <Process />
        <Gallery />
        <Authority />
        <FAQ />
        <FinalCTA />
        <ContactForm />
      </main>
      <Footer />
      <MobileBottomBar />
    </div>
  );
}